module.exports = __webpack_public_path__ + "6796c98c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/world_map_dots@2x.png
// module id = 827
// module chunks = 0 1 2 3 4 5